import { useTranslation } from "react-i18next";

import { subsidiaries, Subsidiary } from "../types";

export const useAllowedCurrencyForSubsidiary = (
  subsidiary: Subsidiary,
  shortHand: boolean = false
) => {
  const { t } = useTranslation();

  // used for Billing forms
  const fullNames = {
    CERTN_CANADA: [
      { name: t("Canadian Dollar"), id: "CAD" },
      { name: t("United States Dollar"), id: "USD" },
    ],
    CERTN_USA: [
      { name: t("Canadian Dollar"), id: "CAD" },
      { name: t("United States Dollar"), id: "USD" },
    ],
    CREDENCE: [
      { name: t("United States Dollar"), id: "USD" },
      { name: t("Euro"), id: "EUR" },
      { name: t("Great Britain Pound"), id: "GBP" },
    ],
    INTERCHECK: [
      { name: t("Australian Dollar"), id: "AUD" },
      { name: t("United States Dollar"), id: "USD" },
    ],
  };

  // used for CurrencyFilter
  const shortHands = {
    CERTN_CANADA: [
      { name: "CAD", id: "CAD" },
      { name: "USD", id: "USD" },
    ],
    CERTN_USA: [
      { name: "CAD", id: "CAD" },
      { name: "USD", id: "USD" },
    ],
    CREDENCE: [
      { name: "USD", id: "USD" },
      { name: "EUR", id: "EUR" },
      { name: "GBP", id: "GBP" },
    ],
    INTERCHECK: [
      { name: "AUD", id: "AUD" },
      { name: "USD", id: "USD" },
    ],
  };

  if (shortHand)
    return shortHands[subsidiary] || shortHands[subsidiaries.CERTN_CANADA];
  return fullNames[subsidiary] || fullNames[subsidiaries.CERTN_CANADA];
};
